import MaterialButton from '@material-ui/core/Button'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React, { Fragment, ReactNode } from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contained: {
      '&:hover': {
        backgroundColor: theme.buttonHoverBackground,
      },
      '& .MuiButton-label': {
        color: '#fff',
      },
    },
    fullWidth: {
      '&.MuiButton-fullWidth': {
        width: '95%',
      },
    },
    primary: {
      backgroundColor: theme.primaryButtonColor,
    },
  })
)

export interface IButtonProps {
  href?: string
  target?: string
  children: ReactNode
  color?: string
  onClick?: (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  disabled?: boolean
  fullWidth?: boolean
  variant?: 'outlined' | 'text' | 'contained'
  type?: 'button' | 'submit'
  ['data-pricingcalculator-element']?: string
  ['data-upload-artwork-element']?: string

  primary?: boolean
}

const Button = (props: IButtonProps) => {
  const {
    children,
    color,
    onClick,
    href,
    target,
    disabled,
    fullWidth = false,
    variant = 'contained',
    type = 'button',
  } = props
  const classes = useStyles()
  const contents = (
    <>
      <div className="mdc-button__ripple"></div>
      <span className="mdc-button__label">{children}</span>
      <div className="mdc-button__touch"></div>
    </>
  )
  const attrs: Record<string, string> = {}
  if (props['data-pricingcalculator-element']) {
    attrs['data-pricingcalculator-element'] =
      props['data-pricingcalculator-element']
  }
  if (props['data-upload-artwork-element']) {
    attrs['data-upload-artwork-element'] = props['data-upload-artwork-element']
  }

  const btn = (
    <MaterialButton
      {...attrs}
      type={type}
      fullWidth={fullWidth}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      className={clsx({
        [`si-background-color-${color}`]: variant === 'contained',
        [`si-text-color-white`]: variant === 'contained',
        [classes.contained]: variant === 'contained',
        [classes.fullWidth]: fullWidth,
        [`si-border-color-${color}`]: variant === 'outlined',
        [classes.primary]: props.primary,
      })}
    >
      {contents}
    </MaterialButton>
  )

  return (
    <div className="si-button">
      <div className="mdc-touch-target-wrapper">
        {href && (
          <a {...attrs} href={href} target={target}>
            {btn}
          </a>
        )}
        {!href && btn}
      </div>
    </div>
  )
}

export default Button
